// src/components/runs/RunsFilters.jsx
import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

const STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
];

const RunsFilters = ({
  statusFilter,
  onStatusFilterChange,
  visibleCount,
  totalRuns,
}) => {
  const { theme } = useTheme();

  const activeStyle = {
    background: `linear-gradient(135deg, ${theme.primary[600]} 0%, ${theme.secondary[600]} 100%)`,
    color: '#fff',
    border: 'none',
  };

  return (
    <section className="mb-6 flex flex-col gap-3 rounded-2xl bg-white p-4 shadow-sm border border-slate-200 sm:flex-row sm:items-center sm:justify-between">
      {/* Filter Pills */}
      <div className="flex flex-wrap gap-2">
        {STATUS_OPTIONS.map((opt) => {
          const isActive = statusFilter === opt.value;

          return (
            <button
              key={opt.value}
              onClick={() => onStatusFilterChange(opt.value)}
              className="rounded-full px-4 py-1.5 text-xs font-medium transition-all border border-slate-300 hover:bg-slate-100"
              style={isActive ? activeStyle : {}}
            >
              {opt.label}
            </button>
          );
        })}
      </div>

      {/* Count */}
      <p className="text-xs text-slate-600">
        Showing{' '}
        <span className="font-semibold text-slate-800">{visibleCount}</span>{' '}
        of{' '}
        <span className="font-semibold text-slate-800">
          {totalRuns}
        </span>{' '}
        runs
      </p>
    </section>
  );
};

export default RunsFilters;
